import React, { useState, useEffect } from 'react';
import {Box, Flex, NumberInput, Radio, Select, Switch, TextInput} from '@mantine/core';
import VariableSelectWrite from "../../../GlobalComponent/VariableSelectWrite";
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";

const MouseMovement = (props) => {
    const [dataState, setDataState] = useState({
        selectorType: props?.nodeData?.data?.options?.selectorType ?? 'selector',
        elementSelect: props?.nodeData?.data?.options?.elementSelect ?? '',
        elementOrder: props?.nodeData?.data?.options?.elementOrder ?? 'fixed',
        fixedElement: props?.nodeData?.data?.options?.fixedElement ?? 1,
        randomElementFrom: props?.nodeData?.data?.options?.randomElementFrom ?? 1,
        randomElementTo: props?.nodeData?.data?.options?.randomElementTo ?? 50,
        x: props?.nodeData?.data?.options?.x ?? 0,
        y: props?.nodeData?.data?.options?.y ?? 0,
        focus: props?.nodeData?.data?.options?.focus ?? false,
        mouse_human: props?.nodeData?.data?.options?.mouse_human ?? false,
    });

    const handleSelector = (type, value) => {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            setDataState({...dataState, [type]: value});
        } else {
            setDataState({...dataState, [type]: value.target.value});
        }
    }

    useEffect(() => {
        console.log(dataState)
        props.handleSetDataBaseModal(dataState)
    }, [props, dataState])

    return (
        <Box>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <Radio.Group
                    value={dataState.selectorType}
                    label="Choose type"
                    onChange={(e) => {
                        handleSelector('selectorType', e)
                    }}
                    name="element-exists"
                >
                    <Radio value="selector" label="Selector" />
                    <Radio value="coordinates" label="Coordinates" />
                </Radio.Group>
                <Switch
                    label="Mouse move human"
                    checked={!!dataState.mouse_human}
                    style={{ marginLeft: '24px' }}
                    onClick={() => handleSelector('mouse_human', !dataState.mouse_human)}
                />
            </div>
            {dataState.selectorType === "selector" &&
                <>
                    <VariableSelectWrite
                        style={{marginBottom:"10px"}}
                        dataState={dataState.elementSelect} label="Select element" placeholder="Please enter the element, such as #email input"
                        setDataState={handleSelector}
                        handleData={(e) => {
                            handleSelector('elementSelect', e)
                        }}
                        handleSelect={(e) => {
                            handleSelector('elementSelect', e.newValue)
                        }}
                    />
                    <Flex
                        mih={50}
                        gap="md"
                        justify="flex-start"
                        align="flex-start"
                        direction="row"
                        wrap="wrap"
                    >
                        <Select
                            value={dataState.elementOrder}
                            label="Element order"
                            placeholder="Pick one"
                            style={{width:"150px"}}
                            data={[
                                { value: 'fixed', label: 'Fixed Value' },
                                { value: 'random', label: 'Random Value' },
                            ]}
                            onChange={(e) => {
                                handleSelector('elementOrder', e)
                            }}
                        />
                        {dataState.elementOrder === "fixed" &&
                            <VariableNumberInput
                                style={{width:"200px"}}
                                label=" "
                                dataState={dataState.fixedElement}
                                handleData={(e) => {
                                    handleSelector('fixedElement', e)
                                }}
                            />
                        }
                        {dataState.elementOrder === "random" &&
                            <>
                                <NumberInput
                                    style={{width:"150px"}}
                                    value={dataState.randomElementFrom}
                                    label="from"
                                    min={1}
                                    onChange={(e) => {
                                        handleSelector('randomElementFrom', e)
                                    }}
                                />
                                <NumberInput
                                    style={{width:"150px"}}
                                    value={dataState.randomElementTo}
                                    label="to"
                                    min={1}
                                    onChange={(e) => {
                                        handleSelector('randomElementTo', e)
                                    }}
                                />
                            </>
                        }
                    </Flex>

                    <Select
                        value={dataState.focus}
                        label="Focus"
                        placeholder="Pick one"
                        style={{width:"150px", marginTop:"10px"}}
                        data={[
                            { value: false, label: 'False' },
                            { value: true, label: 'True' },
                        ]}
                        onChange={(e) => {
                            handleSelector('focus', e)
                        }}
                    />
                </>
            }
            {dataState.selectorType === "coordinates" &&
                <>
                    <VariableSelectWrite
                        label="Enter X coordinate"
                        dataState={dataState.x}
                        handleData={(e) => {
                            handleSelector('x', e);
                        }}
                        handleSelect={(e) => {
                            handleSelector('x', e.newValue)
                        }}
                    />
                    <VariableSelectWrite
                        label="Enter Y coordinate"
                        dataState={dataState.y}
                        handleData={(e) => {
                            handleSelector('y', e);
                        }}
                        handleSelect={(e) => {
                            handleSelector('y', e.newValue)
                        }}
                    />
                </>
            }
        </Box>
    );
}

export default MouseMovement;
